module.exports = __webpack_public_path__ + "img/def8420.png";